import React from "react";
import LayOut from "../../components/LayOut";

const DeleteProject = () => {
  return (
    <LayOut>
      <div>DeleteProject</div>
    </LayOut>
  );
};

export default DeleteProject;
